
import { Toggle } from '05-ui-kit';
import { onMounted, ref, shallowRef } from '@vue/composition-api';
const __sfc_main = {};
__sfc_main.props = {
  item: {
    key: "item",
    required: true,
    type: Object
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const overflow = ref(0);
  const paddingY = ref(0);
  const question = shallowRef<HTMLDivElement>();
  onMounted(() => rootEl());
  function rootEl() {
    if (question.value) {
      paddingY.value = Number(window.getComputedStyle(question.value).paddingTop.slice(0, -2)) + Number(window.getComputedStyle(question.value).paddingBottom.slice(0, -2));
      overflow.value = question.value.scrollHeight - question.value.offsetHeight;
    }
  }
  return {
    overflow,
    paddingY,
    question
  };
};
__sfc_main.components = Object.assign({
  Toggle
}, __sfc_main.components);
export default __sfc_main;
